for (
  var allAudios = document.querySelectorAll(".product-video"),
    playPauseBtns = document.querySelectorAll(".play-btn"),
    i = 0;
  i < playPauseBtns.length;
  i++
)
  playPauseBtns[i].addEventListener("click", function () {
    var a = this.previousElementSibling;
    if (a.paused) {
      a.play(),
        (this.innerHTML =
          "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/pause-icon.svg?v=1680862365' alt='play' loading='lazy'/></span>");
      for (var e = 0; e < allAudios.length; e++)
        allAudios[e] != a &&
          (allAudios[e].pause(),
          (playPauseBtns[e].innerHTML =
            "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/newplay-icon.svg?v=1680862153' alt='pause' loading='lazy'/></span>"));
    } else a.pause(), (this.innerHTML = "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/newplay-icon.svg?v=1680862153' alt='pause' loading='lazy'/></span>");
  });
function remove_Product(a) {
  console.log(a);
  $.post({ url: "/cart/update.js", data: { updates: a } }).done(function (a) {
    location.reload();
  });
}
window.addEventListener("scroll", function () {
  let a = document.querySelector(".body"),
    e = document.querySelector(".site-header"),
    s = window.scrollY;
  s > 40
    ? (a.classList.add("fixed"),
      e.classList.add("site-header-sticky--scrolled"))
    : (e.classList.remove("site-header-sticky--scrolled"),
      a.classList.remove("fixed"));
}),
  $(".play-orange").on("click", (a) => {
    var e,
      s = $(a.currentTarget),
      l = $(".play-orange-progress"),
      r = $(a.currentTarget).find("audio");
    if (
      ($(".addon-play audio").each((a, e) => {
        e.pause(), $(e).parent().removeClass("playing");
      }),
      s.hasClass("playing")
        ? (r[0].pause(), (e = !0), s.removeClass("playing"))
        : (r[0].play(), s.addClass("playing"), (e = !1)),
      !1 == e &&
        (playingInterval = setInterval(function () {
          var a = Math.floor(r[0].currentTime),
            e = Math.floor(r[0].duration);
          l.attr({ value: r[0].currentTime, max: e });
          var t = $(".play-orange-info"),
            n = parseInt(e / 60);
          t.html(n + ":" + ("0" + Math.abs(e.toString() - 60 * n)).slice(-2)),
            e == a &&
              (clearInterval(playingInterval), s.removeClass("playing"));
        }, 100)),
      e)
    )
      return clearInterval(playingInterval), !1;
  }),
  $("body").on("click", ".player-prod .play-orange-progress", function (a) {
    var e,
      s = $(this).closest(".player-prod").find("audio")[0],
      l = $(this).width(),
      r = $(this).attr("max"),
      t = (Math.round((a.offsetX / l) * 100) * r) / 100;
    $(this).val(t), (s.currentTime = +t);
  }),
  $(".addon-play").on("click", (a) => {
    var e = $(a.currentTarget);
    a.preventDefault(),
      $(".play-orange audio")[0].pause(),
      $(".play-orange").removeClass("playing");
    var s = $(a.currentTarget).find("audio");
    e.hasClass("playing")
      ? ($(".addon-play audio").each((a, e) => {
          e.pause(), $(e).parent().removeClass("playing");
        }),
        s[0].pause(),
        e.removeClass("playing"))
      : ($(".addon-play audio").each((a, e) => {
          e.pause(), $(e).parent().removeClass("playing");
        }),
        s[0].play(),
        e.addClass("playing"));
    var l = setInterval(function () {
      var a = Math.floor(s[0].currentTime);
      Math.floor(s[0].duration) == a &&
        (clearTimeout(l), e.removeClass("playing"));
    }, 100);
  }),

  
  $("body").on("click", ".cart-item__remove-link", function (a) {
    var e = {};
    a.preventDefault();
    let s = $(this).parents(".cart-item").attr("data-unique");
    $(`.cart-item[data-unique=${s}]`).each(function () {

      // CD Arshit
      e[$(this).attr("data-cartitem-key")] = 0;
      // e[$(this).attr("data-cartitem-id")] = 0;
      
    }),
      console.log(e);
    remove_Product(e);
  });

var allAudiosRoyalistCollectionProduct = document.querySelectorAll(".product-audio");
var playPauseBtnRoyaliyCollectionProduct = document.querySelectorAll(".royalist-music-play-btn");
for (var i = 0; i < playPauseBtnRoyaliyCollectionProduct.length; i++) {
  playPauseBtnRoyaliyCollectionProduct[i].addEventListener(
    "click",
    function () {
      var audio = this.previousElementSibling;
      if (audio.paused) {
        audio.play();
        this.innerHTML =  "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/pause-icon.svg?v=1680862365' alt='play' loading='lazy'/></span>";
        for (var j = 0; j < allAudiosRoyalistCollectionProduct.length; j++) {
          if (allAudiosRoyalistCollectionProduct[j] != audio) {
            allAudiosRoyalistCollectionProduct[j].pause();
            playPauseBtnRoyaliyCollectionProduct[j].innerHTML = "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/royality-free-music-play.svg?v=1681112488' alt='pause' loading='lazy'/></span>";
          }
        }
      } else {
        audio.pause();
        this.innerHTML =  "<span><img src='https://cdn.shopify.com/s/files/1/0078/6723/6407/files/royality-free-music-play.svg?v=1681112488' alt='pause' loading='lazy'/></span>";
      }
    }
  );
}

// CD Sanket
if($('body').hasClass('template-cart')){
  $.ajax({
    url: '/cart',
    type: 'GET',
    dataType: 'json',
    success: function (cart){
       var items = cart.items.length;
      if($('.cartitems .cart-item').length != items){
        location.reload(true);
      }
    }
  })
}

 document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-static-header').clientHeight + 'px');
	window.addEventListener('resize', function () {
	document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-static-header').clientHeight + 'px');
	});